<div class="edp-contract-list-welcome contract-list-header mb-3 mb-md-4">
    <h2 class="mb-2">{{ "pt.edp.edponline.contract.list.consumption.local.welcome" | translate }}</h2>
    <h3 class="user-name mb-0">{{userName}}</h3>
</div>